import { ArticleFormat, BrandKey } from '../../../__generated__/queries-web';
import { INPUT_TPL } from '../templates/article.tpl';
import { MEDIA_TPL } from '../templates/media.tpl';

export const renderInputFromTemplate = (
  format: ArticleFormat,
  brandKey: BrandKey,
) => (name: string): boolean => {
  if (!INPUT_TPL[brandKey]) {
    return false;
  }
  const isInTemplate = INPUT_TPL[brandKey][format.toUpperCase()].includes(name);
  return !!isInTemplate;
};

export const renderMediaFromTemplate = (
  format: ArticleFormat,
  brandKey: BrandKey,
) => {
  if (!MEDIA_TPL[brandKey]) {
    return [];
  }

  const allowedMedia = MEDIA_TPL[brandKey].FORMAT[format.toUpperCase()];
  return allowedMedia || [];
};
